<section class="content">
  <app-breadcrumbs type="profileReport"></app-breadcrumbs>
  <div class="card" *ngIf="infoVisibility">
    <div class="card-body text-center">
      <div class="text-right">
        <a (click)="hideInfo()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
          </svg>
        </a>
      </div>
      <div *ngIf="(profileState | async).audit !== null && (profileState | async).audit.status === 1">
        <img class="placeholder-icon mt-3" src="./assets/images/checked.png"/>
        <h3 class="mt-3">The profile has been added correctly!</h3>
        <div class="mt-3">
          <p>
            The report is being prepared. This may take time because we are analyzing posts, likes and dislikes and audience data in real time. Results may be visible after a few hours.
            We will inform you by email when the report is ready.
          </p>
        </div>
      </div>
      <div *ngIf="(profileState | async).profileDetail !== null && (profileState | async).profileDetail.is_private === true">
        <img class="placeholder-icon mt-3" ngSrc="./assets/images/cancel.png"/>
        <h3 class="mt-3">Profile could not be added</h3>
        <div class="mt-3">
          <p>
            This profile is private. It is not possible to prepare a report for a private account.
          </p>
        </div>
      </div>
      <div class="d-sm-flex justify-content-between mt-4 mt-sm-5">
        <a routerLink="/audits" class="btn btn-default m-1 m-sm-0">Go back to reports list</a>
        <a routerLink="/audit/add" class="btn btn-blue btn-animated px-4 m-1 m-sm-0">Add a new report</a>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="(profileState | async).profileDetail !== null">
    <div class="col-md-12">
      <h6 class="content-header">Profile</h6>
      <div class="spinner" *ngIf="!(profileState | async).loader['audit']['detail']"></div>
      <div class="card" [ngClass]="!(profileState | async).loader['audit']['detail'] ? 'background-loader' : ''">
        <div class="card-body profile-info">
          <div class="row">
            <div class="col-md-3">
              <div class="text-center">
                <a class="avatar-content" href="{{'https://www.instagram.com/' + (profileState | async).profileDetail.username}}" target="_blank" >
                  <img class="avatar"
                       default="./assets/images/user-avatar.png"
                       [src]="(profileState | async).profileDetail.profile_pic_url"
                       onerror="this.onerror=null;this.src='./assets/images/icons/face.png'"
                       alt="Audited profile avatar" style="width: 170px; height: 170px; border-radius: 50%"/>
                  <img class="icon-platform" src="assets/images/icons/instagram-2.png"/>
                </a>
              </div>
            </div>
            <div class="col-md-8 profile-details">
              <div>
                <h1 class="profile-name">
                  <a href="{{'https://www.instagram.com/' + (profileState | async).profileDetail.username}}" target="_blank">
                    &#64;{{(profileState | async).profileDetail.username}}</a>
                </h1>
                <p class="mb-2">{{(profileState | async).profileDetail.full_name}}</p>
                <p class="profile-description" *ngIf="(profileState | async).audit !== null && (profileState | async).audit.status == 2">
                  Generated on {{(profileState | async).audit.added_time * 1000 | date}}
                </p>
              </div>


              <div class="report-results">
                <div class="b-left">
                  <h2>{{(profileState | async).profileDetail.media_count | shortcutNumbers}}</h2>
                  <p class="sub-text">Posts</p>
                </div>
                <div class="b-left">
                  <h2>{{(profileState | async).profileDetail.followed_by | shortcutNumbers}}</h2>
                  <p class="sub-text">Followers</p>
                </div>
                <div class="b-left">
                  <h2>{{(profileState | async).profileDetail.follows | shortcutNumbers}}</h2>
                  <p class="sub-text">Followed</p>
                </div>
                <div class="b-left">
                  <app-audit-no-mention type="value">
                    <h2 *ngIf="((profileState | async).audit !== null) && (profileState | async).followerEngage !== null">
                      {{(profileState | async).followerEngage.engage_count | number:'1.2'}}%
                    </h2>
                  </app-audit-no-mention>
                  <p class="sub-text">
                    ER
                    <a data-tooltip="Percent of followers who liked or commented the post (last 30 days)">
                      <img class="icon-info" src="./assets/images/icons/info.png"/>
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <h6 class="content-header">Reliability</h6>
    <div class="card">
      <div class="card-tabs">
        <ul class="tabs" role="tablist">
          <li class="tabs-item active">
            <a>
              Followers
            </a>
          </li>
          <li class="tabs-item">
            <a>
              PRV & Business
            </a>
          </li>
        </ul>
      </div>
      <div>
        <div class="card-xl">
          <div class="row m-0">
            <div class="col-md-6 card-body border-right no-border-sm">
                <div class="chart-title flex flex-wrap">
                  <img class="icon-title" src="./assets/images/icons/followers.png"/>
                  <div>
                    <h3 class="card-header">
                      Quality followers
                    </h3>
                  </div>
                </div>
              <div class="mt-3">
                <div class="card-loading">
                  <div class="card-loading-content"></div>
                </div>
              </div>
            </div>
            <div class="col-md-6 card-body">
              <div class="chart-title flex flex-wrap">
                <img class="icon-title" src="./assets/images/icons/quality.png"/>
                <div>
                  <h3 class="card-header">
                    Quality distribution
                  </h3>
                </div>
              </div>
              <div class="mt-3">
                <div class="card-loading">
                  <div class="card-loading-content"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <h6 class="content-header">Profile details</h6>
    <div class="card">
      <div class="card-tabs">
        <ul class="tabs" role="tablist">
          <li class="tabs-item active">
            <a>
              Total followers
            </a>
          </li>
          <li class="tabs-item">
            <a >
              Quality followers
              <a data-tooltip="Demographics analysis of quality followers">
                <img class="icon-info" src="./assets/images/icons/info.png" />
              </a>
            </a>
          </li>
        </ul>
      </div>
      <div class="card-xl" >
        <div class="row m-0">
          <div class="col-md-6 card-body border-right border-bottom no-border-sm">
              <h3 class="card-header">
                <img class="icon-title" src="./assets/images/icons/gender.png"/>
                Gender
                <a data-tooltip="Sex - followers' analysis">
                  <img class="icon-info" src="./assets/images/icons/info.png" />
                </a>
              </h3>
              <div class="mt-3">
                <div class="card-loading">
                  <div class="card-loading-content"></div>
                </div>
              </div>
          </div>
          <div class="col-md-6 card-body border-bottom no-border-sm">
              <h3 class="card-header">
                <img class="icon-title" src="./assets/images/icons/age.png"/>
                Age
                <a data-tooltip="Age - followers' age">
                  <img class="icon-info" src="./assets/images/icons/info.png" />
                </a>
              </h3>
            <div class="mt-3">
              <div class="card-loading">
                <div class="card-loading-content"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="row m-0">
          <div class="col-md-6 card-body border-right no-border-sm">
              <h3 class="card-header">
                <img class="icon-title" src="./assets/images/icons/countries.png"/>
                Language
                <a data-tooltip="The dominant language spoken by followers">
                  <img class="icon-info" src="./assets/images/icons/info.png" />
                </a>
              </h3>
            <div class="mt-3">
              <div class="card-loading">
                <div class="card-loading-content"></div>
              </div>
            </div>
          </div>
          <div class="col-md-6 card-body">
              <h3 class="card-header">
                <img class="icon-title" src="./assets/images/icons/interests.png"/>
                Interests
                <a data-tooltip="Interests (based on followers activity for example used hashtags)">
                  <img class="icon-info" src="./assets/images/icons/info.png" />
                </a>
              </h3>
            <div class="mt-3">
              <div class="card-loading">
                <div class="card-loading-content"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <h6 class="content-header">Followers location</h6>
    <div class="card">
      <div class="card-tabs">
        <ul class="tabs" role="tablist">
          <li class="tabs-item active">
            <a>
              Followers
            </a>
          </li>
        </ul>
      </div>
      <div>
        <div class="card-xl">
          <div class="row m-0">
            <div class="col-md-6 card-body border-right no-border-sm">
              <div class="chart-title flex flex-wrap">
                <img class="icon-title" src="./assets/images/icons/cities.png"/>
                <div>
                  <h3 class="card-header">
                    Cities
                  </h3>
                </div>
              </div>
              <div class="mt-3">
                <div class="card-loading">
                  <div class="card-loading-content"></div>
                </div>
              </div>
            </div>
            <div class="col-md-6 card-body">
              <div class="chart-title flex flex-wrap">
                <img class="icon-title" src="./assets/images/icons/countries.png"/>
                <div>
                  <h3 class="card-header">
                    Countries
                  </h3>
                </div>
              </div>
              <div class="mt-3">
                <div class="card-loading">
                  <div class="card-loading-content"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-tabs">
      <ul class="tabs" role="tablist">
        <li class="tabs-item active">
          <a>
            Profile activity
            <a data-tooltip="Posting frequency">
              <img class="icon-info" src="./assets/images/icons/info.png" />
            </a>
          </a>
        </li>
        <li class="tabs-item">
          <a>
            Followers activity
            <a data-tooltip="Content activity of followers of the audited profile">
              <img class="icon-info" src="./assets/images/icons/info.png" />
            </a>
          </a>
        </li>
      </ul>
    </div>
    <div class="spinner" *ngIf="!(profileState | async).loader['audit']['mediaAnalyze']"></div>
    <div class="card-xl" [ngClass]="!(profileState | async).loader['audit']['mediaAnalyze'] ? 'background-loader' : ''">
      <div class="row m-0">
        <div class="col-md-6 card-body border-bottom border-right no-border-sm">
          <h3 class="card-header">
            <img class="icon-title" src="./assets/images/icons/hashtag.png"/>
            Popular hashtags
          </h3>
          <div class="mt-3">
            <div class="card-loading">
              <div class="card-loading-content"></div>
            </div>
          </div>
        </div>
        <div class="col-md-6 card-body border-bottom no-border-sm">
          <h3 class="card-header">
            <img class="icon-title" src="./assets/images/icons/tags.png"/>
            Popular tags
          </h3>
          <div class="mt-3">
            <div class="card-loading">
              <div class="card-loading-content"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="row m-0">
        <div class="col-md-6 card-body border-right no-border-sm">
          <h3 class="card-header">
            <img class="icon-title" src="./assets/images/icons/calendar.png"/>
            Profile activity by week days
          </h3>
          <div class="mt-3">
            <div class="card-loading">
              <div class="card-loading-content"></div>
            </div>
          </div>
        </div>
        <div class="col-md-6 card-body border-right no-border-sm">
          <h3 class="card-header">
            <img class="icon-title" src="./assets/images/icons/time.png"/>
            Profile activity by hours
          </h3>
          <div class="mt-3">
            <div class="card-loading">
              <div class="card-loading-content"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <h3 class="card-header">
            Engagement rate by days
            <a data-tooltip="Average engagement rate - checked per day (graph showing dynamics in the last 30 days)">
              <img class="icon-info" src="./assets/images/icons/info.png" />
            </a>
          </h3>
          <div class="mt-3">
            <div class="card-loading">
              <div class="card-loading-content"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-body">
      <div class="mb-3">
        <h3 class="card-header">
          Engagement
          <a data-tooltip="Average engagement of the audited profile - number of interactions versus number of followers">
            <img class="icon-info" src="./assets/images/icons/info.png" />
          </a>
        </h3>
        <p class="text-medium">Compared to average values for similar accounts (by numbers of followers)</p>
      </div>
      <div class="card-loading">
        <div class="card-loading-content card-loading-content-sm"></div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <h6 class="content-header">
        Average engagement rate table
        <a data-tooltip="Table presenting ranges of followers and average engagement">
          <img class="icon-info" src="./assets/images/icons/info.png"/>
        </a>
      </h6>
      <div class="card card-loading">
        <div class="card-body">
          <div class="card-loading-content card-loading-content-sm"></div>
        </div>
      </div>
    </div>
  </div>

</section>

